import { render, staticRenderFns } from "./optionItems.vue?vue&type=template&id=44ab5700"
import script from "./optionItems.vue?vue&type=script&lang=js"
export * from "./optionItems.vue?vue&type=script&lang=js"
import style0 from "./optionItems.vue?vue&type=style&index=0&id=44ab5700&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports